const PlanIds = {
  STANDARDV21LITE: 214,
  STANDARDV21STANDARD: 215,
  STANDARDV21PREMIUM: 216,
  LARGELISTLITEV23: 361,
  LARGELISTPREMIUMV23: 363,
  AUSTRALIA_V1_LITE: 686,
  AUSTRALIA_V1_PREMIUM: 688,
  NEWZEALAND_V1_LITE: 689,
  NEWZEALAND_V1_PREMIUM: 691,
  GREATBRITAIN_V1_LITE: 692,
  GREATBRITAIN_V1_PREMIUM: 694,
  GREATBRITAIN_LEAD_MAGNET_LITE: 697,
  GREATBRITAIN_LEAD_MAGNET_PREMIUM: 699,
  GB_FREE_PLAN: 696,
  UNKNOWN_FREE_PLAN: 310, // https://github.roving.com/ES/myact-react-static/pull/2154#discussion_r372363
};

const PremiumPlanIds = [
  PlanIds.LARGELISTPREMIUMV23,
  PlanIds.STANDARDV21PREMIUM,
  PlanIds.AUSTRALIA_V1_PREMIUM,
  PlanIds.NEWZEALAND_V1_PREMIUM,
  PlanIds.GREATBRITAIN_V1_PREMIUM,
];

export default PlanIds;

export { PremiumPlanIds, PlanIds };
